import { types, actions } from './requests'
export const GETOFFICE_TYPES = {
    ...types('GETOFFICE')
}
export const GETOFFICE_ACTIONS = {
    ...actions('GETOFFICE')
}
